import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import MAINPAGE from "./components/mainpage";
import { Provider } from 'react-redux'
import { store } from './store'
import { Stage, Sprite, Text, useTick } from '@inlet/react-pixi';
// import {configGame,constant} from "./data/config"
import { Ilanguage } from "./interface/Icommon";
import { alllanguage } from "./data/lang/index"
import { lanAssetConfig } from "./data/lang/index"
import * as PIXI from "pixi.js";
import Paytable from "./components/paytable/paytable";
import Autoplay from "./components/autoplay/autoplay";
import AutoplayInCanvas from "./components/autoplay/autoplayInCanvas"
import Menu from "./components/menu/menu";
import Wrapper from "./components/wrapper/wrapper";
import Help from "./components/help/help";
import Layouts from "./components/layouts/layouts";
import Detectdevices from "./components/device/detectdevices";
import MobViewPanel from "./components/mobViewPanel/mobViewPanel";
import { isMobile } from "react-device-detect";
import HtmlElement from "./components/htmlElementPanel/htmlElement";
import ServerComm from "../serverComm/serverComm";
import KeyboardListener
    from "./components/keyboardListeners/keyboardListener";

window.PIXI = PIXI;

interface IProps {
    // app: PIXI.Application

    [x: string]: any;

    // loader: {
    //     config: {string:string}
    // }
}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {
    [x: string]: any;
}

interface IState {
    [x: string]: any;

    width: number,
    height: number,
}

export default class App extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            width: this.props.width,
            height: this.props.height,
        }


    }

    componentDidMount() {
        // debugger
        //  setTimeout(()=>{
        //      window.addEventListener('resize', this.props.updateDimention && this.props.updateDimention.bind(this));
        //  },1000)

        window.addEventListener('resize', this.updateDimensions.bind(this));

    }

    updateDimensions() {


        if (isMobile) {

            if (window.innerHeight > window.innerWidth) {

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        width: this.props.constant.configGame.portraitCanvasWidth,
                        height: this.props.constant.configGame.portraitCanvasHeight,
                    }
                })
            } else {


                this.setState((prevState) => {
                    return {
                        ...prevState,
                        width: this.props.constant.configGame.landscapeCanvasWidth,
                        height: this.props.constant.configGame.landscapeCanvasHeight,
                    }
                })


            }
        } else {


            this.setState((prevState) => {
                return {
                    ...prevState,
                    width: this.props.constant.configGame.canvasWidth,
                    height: this.props.constant.configGame.canvasHeight,
                }
            })
        }


        //  this.calculateCanvas();
    }

    getGameStart(langcode: string = "en") {


        const langObj: Record<any, any> = alllanguage[langcode as keyof typeof alllanguage];
        // let showMobViewPanelPage=false;
        // if(isMobile){
        //     showMobViewPanelPage=true;
        // }
        let { width, height } = this.state
        let PROPS_TO_SEND_MAINPAGE = {
            langcode: langcode,
            langObj: langObj,
            constant: this.props.constant,
            detectDevices: new Detectdevices(),
            lanAssetConfig: lanAssetConfig,
            width: width,
            height: height,
            configGame: this.props.configGame,

        }
        let PROPS_TO_SEND_HtmlElement = {
            langcode: langcode,
            langObj: langObj,
            constant: this.props.constant,
            detectDevices: new Detectdevices(),
            lanAssetConfig: lanAssetConfig,
            width: this.props.configGame.CANVAS_WIDTH,
            height: this.props.configGame.CANVAS_HEIGHT,
            configGame: this.props.configGame,

        }
        return (<div>
            <Stage width={width} height={height}>
                <Provider store={this.props.Gamestore}>
                    <MAINPAGE {...PROPS_TO_SEND_MAINPAGE} />

                    {/*<IntroductionInCanvas langcode={langcode} langObj={langObj} constant={constant}*/}
                    {/*                      detectDevices={new Detectdevices()} lanAssetConfig={lanAssetConfig}*/}
                    {/*                      width={configGame.CANVAS_WIDTH}*/}
                    {/*                      height={configGame.CANVAS_HEIGHT}></IntroductionInCanvas>*/}
                    {/*<DesktopPaytable langObj={langObj} width={configGame.CANVAS_WIDTH}*/}
                    {/*                 height={configGame.CANVAS_HEIGHT}></DesktopPaytable>*/}

                </Provider>
            </Stage>
            <Provider store={this.props.Gamestore}>
                {/*<Paytable langcode={langcode} langObj ={langObj} width={configGame.CANVAS_WIDTH} height={configGame.CANVAS_HEIGHT}></Paytable>*/}
                {/*{showMobViewPanelPage && <MobViewPanel width={configGame.CANVAS_WIDTH} height={configGame.CANVAS_HEIGHT}></MobViewPanel>}*/}
                {/*{ configGame.AUTOPLAY_UI_IN_CANVAS===0 && !showMobViewPanelPage && <Autoplay langcode={langcode} langObj ={langObj} InCanvas={configGame.AUTOPLAY_UI_IN_CANVAS} width={configGame.CANVAS_WIDTH} height={configGame.CANVAS_HEIGHT}></Autoplay>*/}
                {/*}*/}
                {/*{ configGame.MENU_UI_IN_CANVAS===0 && !showMobViewPanelPage  && <Menu langcode={langcode} langObj ={langObj} InCanvas={configGame.MENU_UI_IN_CANVAS} width={configGame.CANVAS_WIDTH} height={configGame.CANVAS_HEIGHT}></Menu>*/}
                {/*}*/}
                <HtmlElement {...PROPS_TO_SEND_HtmlElement}></HtmlElement>
                <Wrapper {...PROPS_TO_SEND_HtmlElement}></Wrapper>
                {/*<Help langcode={langcode} langObj ={langObj}  lanAssetConfig={lanAssetConfig} width={configGame.CANVAS_WIDTH} height={configGame.CANVAS_HEIGHT}></Help>*/}
                <ServerComm></ServerComm>
                <Layouts></Layouts>
                <KeyboardListener {...PROPS_TO_SEND_HtmlElement}></KeyboardListener>

            </Provider>
        </div >);
    }


    render() {
        return (this.getGameStart());
    }
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

//https://www.youtube.com/watch?v=CVpUuw9XSjY

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
